<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">去加油场景介绍</p>
        <p>优惠、便捷、快速、方便的线上加油服务</p>
        <div class="bussinbtn" @click="goBusiness()">立即对接</div>
      </div>
    </div>
    <div class="box-shadow">
      <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
        <p
          v-for="(nl, index) in navList"
          :key="index"
          :class="anchorId == index ? 'nowAnchor' : ''"
          @click="changeanchorId(index, nl.id)"
        >
          {{ nl.text }}
        </p>
      </div>
    </div>
    <!-- 地图部分 -->
    <section class="scene1-mapCon first-introduce flexDiv mainDivWidth">
      <div class="distribution-map introduceTextImg">
        <img src="static/img/sceneImg/scene01-Fuel/map.png" />
        <div
          class="map-point"
          v-for="(md, index) in mapData"
          :key="index"
          v-bind:style="{ top: md.top, left: md.left }"
        >
          <div class="pulse" :class="md.cls01"></div>
          <div class="pulse2" :class="md.cls02"></div>
          <div class="message-box">
            <span>{{ md.name }}</span>
          </div>
        </div>
      </div>
      <div class="scene1-mapCon-left first-introduceText">
        <p class="textRight mapCover marBotZero">
          接入<span>10,000+</span>座油站
        </p>
        <div class="mapText smallRadius">
          佰付美去加油场景目前已接入中国石油、中国石化、延长壳牌等国内主要品牌油站10，000座以上，业务覆盖广东、四川、陕西、辽宁、湖南、福建、山东、山西等国内20多个省、市、自治区，结合平台丰富的行业营销资源，致力于为广大车主用户提供可靠、实惠的线上加油支付服务。
        </div>
        <p class="textLeft mapCover">覆盖<span>20</span>多个省市自治区</p>
      </div>
    </section>
    <!-- 接入优势 -->
    <section class="joinUp-advantage" id="advantage">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText pointer hoverBlueText">接入优势</h3>
        <p  class="advantageText smallRadius pointer hoverBlueText">
          去加油平台为企业提供可接入式的加油站场景支付优化模块，为企业自有产品或运营平台增加满足刚性需求的功能模块。增加企业自有产品用户的活跃率和忠诚度。同时免除线下维护成本、功能开发成本、服务器成本、活动补贴成本等多方面支出。
        </p>
        <p  class="advantageText smallRadius pointer hoverBlueText">
          企业接入去加油，相当于同时拥有了一套完善的加油站场景支付系统、上百人的运维团队、上千家线下加油站商户、诱人的多方渠道活动资源。丰富企业产品功能、节约企业成本、提升企业品牌形象、建立用户对企业的信任度和忠诚度。
        </p>
        <p  class="advantageText smallRadius pointer hoverBlueText">
          精准营销划分客户、提升企业品牌形象、建立用户对企业的信任度和忠诚度、丰富企业产品功能、降低大商户拓展、提升营销效率、运维及活动营销成本：使自身用户更便利享受加油优惠。
        </p>
      </div>
    </section>
    <!-- 中心功能 -->
    <section class="centerFun" id="centerFun">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">中心功能</h3>
        <div class="flexDiv functionCon">
          <div
            class="pointer hoverBlackText"
            v-for="(cl, index) in centerFunList"
            :key="index"
          >
            <div class="circleradius">
              <img :src="cl.img" />
            </div>
            <p class="whiteText" v-html="cl.text"></p>
          </div>
        </div>
      </div>
    </section>
    <!-- 便捷加油 -->
    <section id="quickReFuel">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">便捷加油</h3>
        <div class="quickReFuel-Con flexDiv">
          <div class="quickImgcon">
            <img src="static/img/sceneImg/scene01-Fuel/quickReFuel01.png" />
            <p>用户</p>
          </div>
          <div class="quickDivCon">
            <p>进入油站</p>
          </div>
          <div class="quickImgcon">
            <img src="static/img/sceneImg/scene01-Fuel/quickReFuel02.png" />
            <p>手机下单</p>
          </div>
          <div class="quickDivCon">
            <p>身份识别</p>
          </div>
          <div class="quickImgcon">
            <img src="static/img/sceneImg/scene01-Fuel/quickReFuel03.png" />
            <p>选择优惠</p>
          </div>
          <div class="quickDivCon">
            <p>付款成功</p>
          </div>
          <div class="quickImgcon">
            <img src="static/img/sceneImg/scene01-Fuel/quickReFuel04.png" />
            <p>加油</p>
          </div>
          <div class="quickDivCon">
            <p>通知放行</p>
          </div>
          <div class="quickImgcon">
            <img src="static/img/sceneImg/scene01-Fuel/quickReFuel01.png" />
            <p>出站</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 产品特色 -->
    <section class="sellingPoint" id="sellingPoint">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">产品特色</h3>
        <div class="sellingPoint-Con flexDiv">
          <div
            class="smallRadius"
            v-for="(spl, index) in sellingPointList"
            :key="index"
          >
            <p class="selTitle" v-text="spl.title"></p>
            <p v-text="spl.text"></p>
          </div>
        </div>
      </div>
    </section>
    <!-- 优惠支付 -->
    <section class="mainDivWidth" id="privilegePay">
      <h3 class="sectionTitle">优惠支付</h3>
      <div class="flexDiv privilegePay">
        <div v-for="(pl, index) in privilegePayList" :key="index">
          <img :src="pl.img" />
          <p v-text="pl.text"></p>
        </div>
      </div>
    </section>
    
    <!-- 接入流程 -->
    <section id="joinUpFlow">
      <h3 class="sectionTitle">接入流程</h3>
      <div class="mainDivWidth smallRadius joinUpFlow h5-joinUpFlow">
        <p class="flowTitle flowTitle-bg01">H5接入</p>
        <div class="definite-flow flow-sixStep flexDiv">
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/h5join01.png" />
            </div>
            <p>申请接入</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/h5join02.png" />
            </div>
            <p>分配渠道地址</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/h5join03.png" />
            </div>
            <p>渠道适配调试</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/h5join04.png" />
            </div>
            <p>活动配置调试</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/h5join05.png" />
            </div>
            <p>联调上线</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/h5join06.png" />
            </div>
            <p>渠道活动推广</p>
          </div>
        </div>
      </div>
      <div class="mainDivWidth smallRadius joinUpFlow api-joinUpFlow">
        <p class="flowTitle flowTitle-bg02">API接入</p>
        <div class="definite-flow flow-sixStep flexDiv">
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/apiJoin01.png" />
            </div>
            <p>申请接入</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/apiJoin02.png" />
            </div>
            <p>配置测试接口</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/apiJoin03.png" />
            </div>
            <p>接口联调</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/apiJoin04.png" />
            </div>
            <p>分配渠道账号</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/apiJoin05.png" />
            </div>
            <p>联调上线</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img src="static/img/sceneImg/scene01-Fuel/apiJoin06.png" />
            </div>
            <p>渠道活动推广</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "sceneFuel",
  data: function() {
    return {
      anchorId: 0,
      navList: [
        { text: "中心功能", id: "centerFun" },
        { text: "接入优势", id: "advantage" },
        { text: "便捷加油", id: "quickReFuel" },
        { text: "产品特色", id: "sellingPoint" },
        { text: "优惠支付", id: "privilegePay" },
        { text: "接入流程", id: "joinUpFlow" }
      ],
      mapData: [
        { top: "54%", left: "58%", name: "陕西", cls01: "", cls02: "delay01" },
        {
          top: "30%",
          left: "81%",
          name: "辽宁",
          cls01: "delay01",
          cls02: "delay02"
        },
        {
          top: "46%",
          left: "74%",
          name: "山东",
          cls01: "delay04",
          cls02: "delay05"
        },
        {
          top: "24%",
          left: "86%",
          name: "吉林",
          cls01: "delay02",
          cls02: "delay03"
        },
        {
          top: "47%",
          left: "38%",
          name: "青海",
          cls01: "delay03",
          cls02: "delay04"
        },
        {
          top: "34%",
          left: "39%",
          name: "甘肃",
          cls01: "delay01",
          cls02: "delay02"
        },
        {
          top: "41%",
          left: "69%",
          name: "河北",
          cls01: "delay04",
          cls02: "delay05"
        },
        { top: "46%", left: "64%", name: "山西", cls01: "", cls02: "delay01" },
        {
          top: "52%",
          left: "67%",
          name: "河南",
          cls01: "delay02",
          cls02: "delay03"
        },
        {
          top: "28%",
          left: "72%",
          name: "天津",
          cls01: "delay03",
          cls02: "delay04"
        },
        {
          top: "36%",
          left: "52%",
          name: "内蒙",
          cls01: "delay01",
          cls02: "delay02"
        },
        {
          top: "56%",
          left: "79%",
          name: "江苏",
          cls01: "delay04",
          cls02: "delay05"
        },
        { top: "60%", left: "75%", name: "安徽", cls01: "", cls02: "delay01" },
        {
          top: "60%",
          left: "81%",
          name: "上海",
          cls01: "delay01",
          cls02: "delay02"
        },
        {
          top: "80%",
          left: "68%",
          name: "广东",
          cls01: "delay04",
          cls02: "delay05"
        },
        {
          top: "70%",
          left: "65%",
          name: "湖南",
          cls01: "delay02",
          cls02: "delay03"
        },
        { top: "61%", left: "66%", name: "湖北", cls01: "", cls02: "delay01" },
        {
          top: "80%",
          left: "60%",
          name: "广西",
          cls01: "delay03",
          cls02: "delay05"
        },
        {
          top: "64%",
          left: "45%",
          name: "四川",
          cls01: "delay02",
          cls02: "delay03"
        }
      ],
      // 中心功能
      centerFunList: [
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun01.png",
          text: "油站<br>精准定位"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun02.png",
          text: "规划<br>行驶路线"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun03.png",
          text: "在线<br>下单支付"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun04.png",
          text: "享受<br>平台优惠"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun05.png",
          text: "语音播报<br>驶离油站"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun06.png",
          text: "查看<br>消费记录"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun07.png",
          text: "查看<br>优惠活动"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/centerFun08.png",
          text: "多种<br>支付方式支持"
        }
      ],
      // 产品特色
      sellingPointList: [
        {
          title: "全品牌油站覆盖",
          text:
            "已接入中国石油、中国石化、延长壳牌等国内主要品牌油站10000座以上"
        },
        {
          title: "便捷的在线支付",
          text:
            "整合银联支付、微信支付、支付宝支付、建行龙支付等国内主流在线支付"
        },
        {
          title: "轻应用易移植",
          text: "H5接入、API接入等多种对接形式，接入方便快捷"
        },
        {
          title: "不下车免排队",
          text:
            "用户在线支付，通过语音播报即可离站，避免收银排队，节省用户宝贵时间"
        },
        {
          title: "丰富的营销资源",
          text:
            "汇集以中国银联、中国建设银行银行、中国平安、中国联通等合作方为代表的50多家行业客户资源"
        }
      ],
      // 优惠支付
      privilegePayList: [
        { img: "static/img/sceneImg/scene01-Fuel/pay01.png", text: "选择油站" },
        {
          img: "static/img/sceneImg/scene01-Fuel/pay02.png",
          text: "填写加油金额"
        },
        {
          img: "static/img/sceneImg/scene01-Fuel/pay03.png",
          text: "选择支付方式、享受优惠"
        },
        { img: "static/img/sceneImg/scene01-Fuel/pay04.png", text: "支付成功" }
      ],
      idconts:"",
    };
  },
  created(){
    this.idconts = this.getQueryString('idcont');
  },
  mounted() {
    if(this.idconts){
      $(".mainCon").css('margin-top','0')
      $("#nava").css('display','none')
      $(".scene-Header").css('display','none')
      $(".servebanner").css('display','none')
      $(".footer").css('display','none')
    }
  },
  methods: {
    goBusiness(){
      this.$router.push({"path": "/cooperate"})
    },
    changeanchorId(num, id) {
      this.anchorId = num;
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      this.backTop = true;
      return false; // 返回false可以避免在原链接后加上#
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return r[2]; return null;
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/sceneCss/sceneStyle";
@import "../../assets/css/sceneCss/sceneOne";
</style>



// WEBPACK FOOTER //
// src/pages/scenePage/scene1-fueling.vue